import { ClaimCandidatesGroupedTable } from "../../components/claims/ClaimCandidatesGroupedTable";
import { PageHeader } from "../../components/layout/PageHeader";
import { OVERVIEW_ONLY } from "../../lib/demoMode";

export function PotentialClaimsReportPage({
  basePath = "/reports/potential",
  ledgerReadyOnly = false,
}: { basePath?: string; ledgerReadyOnly?: boolean } = {}) {
  return (
    <div className="page-stack">
      <PageHeader
        title="Potential claims"
        description={
          ledgerReadyOnly
            ? "Newly flagged claim candidates on Ledger ready contracts (tariff ledger on file) - the same set the Overview card totals. Mark a claim recovered or reject it."
            : OVERVIEW_ONLY
            ? "Newly flagged claim candidates not yet reviewed. Mark a claim recovered or reject it."
            : "Newly flagged claim candidates not yet reviewed. Accept a group to move all FY tranches into the in-progress pipeline."
        }
      />
      <ClaimCandidatesGroupedTable
        statusFilter={["identified"]}
        detailPath={(id) => `${basePath}/${id}`}
        showActions
        actionPreset="review"
        emptyMessage={ledgerReadyOnly ? "No potential claims on Ledger ready contracts yet." : "No potential claims flagged yet."}
        ledgerReadyOnly={ledgerReadyOnly}
      />
    </div>
  );
}
